import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"
import "./index.scss"
import PageContainer from "components/common/PageContainer"
import TopicCard from "components/card/topic-card"
import Spinner from "components/common/spinner"
import { FORUM_MODAL_TYPES, RESPONSE_MODAL_TYPES } from "constants/modal-types"
import HeroHeader from "components/hero-header/index"
import { Link } from "react-router-dom"

import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import {
  getSchoolForums,
  getSchoolForumsSummary,
  getSchoolForumsUnanswered,
  showForumModal,
  setForumQuestionData,
  upvoteForumQuestion,
  downvoteForumQuestion,
  closeForumQuestion,
} from "store/school/actions"

import { showConfirmModal, closeConfirmModal } from "store/user/actions"

import history from "app/history"
import Button from "components/common/Button"

class Forums extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchParam: "",
      searchMode: false,
      enableSearch: false,
      enableButton: true,
      slug: null,
      activeTab: 0,
    }
  }

  componentDidMount() {
    const {
      school: { schoolData },
    } = this.props

    if (!isEmpty(schoolData)) {
      this.getForums()
    }

    document.addEventListener("scroll", this.trackScrolling)
  }

  componentDidUpdate(prevProps) {
    const {
      school: { schoolData: prevSchoolData = {} },
    } = prevProps

    const {
      school: { schoolData = {} },
    } = this.props

    if (schoolData.id && prevSchoolData.id !== schoolData.id) {
      this.getForums()
    }
  }

  getForums() {
    const {
      school: { schoolData },
      getSchoolForums,
      getSchoolForumsSummary,
      getSchoolForumsUnanswered,
    } = this.props

    const schoolId = schoolData.id

    getSchoolForums({ schoolId, page: 1 })
    getSchoolForumsSummary({ schoolId })
    getSchoolForumsUnanswered({ schoolId, page: 1 })

    this.setState({
      searchMode: false,
    })
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.trackScrolling)
  }

  fetchMoreData = () => {
    const {
      school: { forums, forumsUnanswered, schoolData },
      getSchoolForums,
      getSchoolForumsUnanswered,
    } = this.props

    const schoolId = schoolData.id

    if (forums?.meta?.page < forums?.meta?.pages) {
      getSchoolForums({ schoolId, page: forums.meta.page + 1 })
    }

    if (forumsUnanswered?.meta?.page < forumsUnanswered?.meta?.pages) {
      getSchoolForumsUnanswered({
        schoolId,
        page: forumsUnanswered.meta.page + 1,
      })
    }
  }

  handleEditQuestion = (question, source) => {
    const { showForumModal, setForumQuestionData } = this.props

    setForumQuestionData({ ...question, source })

    showForumModal({
      type: FORUM_MODAL_TYPES.QUESTION,
      isEdit: true,
    })
  }

  handleCloseQuestion = (question, source) => {
    const { setForumQuestionData, closeForumQuestion, showConfirmModal } =
      this.props

    showConfirmModal({
      modalType: RESPONSE_MODAL_TYPES.WARNING,
      header: "Close this question?",
      message:
        "Other students will still be able to post comments or submit answers.",
      confirmLabel: "Yes, close it",
      confirmAction: () => {
        setForumQuestionData({ ...question, source })
        closeForumQuestion(question.id)
      },
    })
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById("forums")
    if (this.isBottom(wrappedElement)) {
      this.fetchMoreData()
      document.removeEventListener("scroll", this.trackScrolling)
    }
  }

  enableSearch = () => {
    this.setState({
      enableSearch: true,
      enableButton: false,
    })
  }

  disableSearch = () => {
    this.setState({
      enableSearch: false,
      enableButton: true,
    })
  }

  handleSearch = async (e) => {
    const { name, value } = e.currentTarget

    if (e.key === "Enter" && value !== "") {
      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout)
      }

      await this.setState({
        [name]: value,
        enableSearch: true,
        enableButton: false,
      })

      history.push(`/forums/search?keyword=${value}`)
    }
  }

  onChangeTab = (index) => {
    this.setState({
      activeTab: index,
    })
  }

  renderForumTabs() {
    const {
      school: {
        forums: { data },
        isLoadingForums,
        forumsUnanswered: { data: unasweredData },
        isLoadingForumsUnanswered,
        schoolData,
        forumsSummary,
      },
      auth: { studentId },
      upvoteForumQuestion,
      downvoteForumQuestion,
      showForumModal,
    } = this.props

    const { activeTab } = this.state

    const selectedTabStyle = { color: schoolData.primary_color }

    return (
      <Tabs onSelect={this.onChangeTab} selectedTabClassName="select-tab">
        <TabList>
          <div className="overall-stats">
            <p className="title">Total Questions</p>
            <h4 className="question">{forumsSummary.questions}</h4>
            <p className="title">Total Answers</p>
            <h4 className="answer">{forumsSummary.answers}</h4>
          </div>
          <div className="recent-tags">
            <h3 className="title">Recent Tags</h3>
            <span className="icon-tags" />
            <div className="tag-list">
              {forumsSummary.recent_tags ? (
                forumsSummary.recent_tags.map((tag, idx) => {
                  return (
                    <Link
                      key={idx}
                      className="tags"
                      to={`/forums/search?tag=${tag}`}
                    >
                      {tag}
                    </Link>
                  )
                })
              ) : (
                <span style={{ color: schoolData.primary_color }}>
                  No tags found.
                </span>
              )}
            </div>
          </div>
          <Button
            label="Start new topic"
            onClick={() => showForumModal({ type: FORUM_MODAL_TYPES.QUESTION })}
          />
          <Tab className="tab" style={activeTab === 0 ? selectedTabStyle : {}}>
            Latest Topic
            <span className="icon-exam" />
          </Tab>
          <Tab className="tab" style={activeTab === 1 ? selectedTabStyle : {}}>
            Unanswered Topic
            <span className="icon-slate" />
          </Tab>
        </TabList>
        <TabPanel>
          <div className="forums-container">
            <div className="topic-list">
              {data?.length ? (
                data?.map((question, i) => {
                  return (
                    <TopicCard
                      key={i}
                      author={
                        question.user?.full_name || question.user?.username
                      }
                      pubTimestamp={question.pub_date}
                      editTimestamp={question.updated}
                      views={question.view_count}
                      reply={question.answer_count}
                      title={question.title}
                      content={question.description}
                      tags={question.tags}
                      id={question.id}
                      upvotes={question.positive_votes}
                      downvotes={question.negative_votes}
                      isAuthor={question.user?.id === parseInt(studentId)}
                      isClosed={question.closed}
                      onClick={() => this.handleClickQuestion(question.id)}
                      onClickEdit={() =>
                        this.handleEditQuestion(question, "latest")
                      }
                      onClickClose={() =>
                        this.handleCloseQuestion(question, "latest")
                      }
                      onClickUpvote={() =>
                        upvoteForumQuestion({
                          id: question.id,
                          source: "latest",
                        })
                      }
                      onClickDownvote={() =>
                        downvoteForumQuestion({
                          id: question.id,
                          source: "latest",
                        })
                      }
                      voteStatus={question?.vote}
                      color={schoolData.primary_color}
                      isList={true}
                    />
                  )
                })
              ) : (
                <div>No questions found</div>
              )}
              <Spinner isFetching={isLoadingForums} />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="forums-container">
            <div className="topic-list">
              {unasweredData?.length ? (
                unasweredData?.map((question, i) => {
                  return (
                    <TopicCard
                      key={i}
                      author={
                        question.user?.full_name || question.user?.username
                      }
                      pubTimestamp={question.pub_date}
                      editTimestamp={question.updated}
                      views={question.view_count}
                      reply={question.answer_count}
                      title={question.title}
                      content={question.description}
                      upvotes={question.positive_votes}
                      downvotes={question.negative_votes}
                      tags={question.tags}
                      id={question.id}
                      isAuthor={question.user?.id === parseInt(studentId)}
                      isClosed={question.closed}
                      onClick={() => this.handleClickQuestion(question.id)}
                      onClickEdit={() =>
                        this.handleEditQuestion(question, "unanswered")
                      }
                      onClickClose={() =>
                        this.handleCloseQuestion(question, "unanswered")
                      }
                      onClickUpvote={() =>
                        upvoteForumQuestion({
                          id: question.id,
                          source: "unanswered",
                        })
                      }
                      onClickDownvote={() =>
                        downvoteForumQuestion({
                          id: question.id,
                          source: "unanswered",
                        })
                      }
                      voteStatus={question?.vote}
                      color={schoolData.primary_color}
                      isList={true}
                    />
                  )
                })
              ) : (
                <div>No questions found</div>
              )}
              <Spinner isFetching={isLoadingForumsUnanswered} />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    )
  }

  render() {
    const routeList = {
      "/": "Home",
      "/forums": "Forums",
    }

    const {
      school: { schoolData },
    } = this.props

    const { searchParam } = this.state

    return (
      <div id="forums">
        <PageContainer className="forums-page">
          <HeroHeader
            title="Forums"
            description="Browse through some of the questions."
            routeList={routeList}
            onChange={this.handleSearch}
            searchValue={searchParam}
            searchEnabled
            activeColor={schoolData.primary_color}
            activeItem="Forums"
          />
          {this.renderForumTabs()}
        </PageContainer>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSchoolForums,
      getSchoolForumsSummary,
      getSchoolForumsUnanswered,
      showForumModal,
      setForumQuestionData,
      upvoteForumQuestion,
      downvoteForumQuestion,
      closeForumQuestion,
      showConfirmModal,
      closeConfirmModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(Forums)
